// fallow-ignore-file -- new contract-import-job API surface with no UI consumer yet; wired up as part of OEO-750
import { z } from 'zod';

import { CONTRACT_IMPORT_JOB_STATUS } from '../constants';
import { zodNewContractFromImportSchema } from '../validations';

// Request payload schema for linking an import job to a contract and
// recording the reviewed snapshot. Exactly one of `contractId` (the user
// matched an existing contract, e.g. via duplicate-check) or `newContract`
// (create a contract from the reviewed data, then link it) must be provided.
export const zodCompleteContractImportJobPayloadSchema = z
  .object({
    contractId: z.uuid().nullish(),
    // Free-form reviewed snapshot, snake_cased on the wire by the ky client.
    finalSnapshot: z.looseObject({}),
    newContract: zodNewContractFromImportSchema.nullish(),
  })
  .refine((data) => Boolean(data.contractId) !== Boolean(data.newContract), {
    error: 'Exactly one of contractId or newContract must be provided.',
    path: ['contractId'],
  });

// Response schema for completing a contract import job.
export const zodCompleteContractImportJobResponseSchema = z.object({
  completedOn: z.iso.datetime({ offset: true }),
  contractId: z.uuid(),
  id: z.uuid(),
  status: z.enum(CONTRACT_IMPORT_JOB_STATUS),
});
